import { getGatewayImageFetch, postDeleteImageMetadata, postGatewayImageNew, postSaveImageMetadata } from '@/api/endpoints';
import { ImageMetadata } from '@/api/models';
import { PhotoUploadHelper } from '@/library';
import { processImageForUpload } from '@/library/PhotoProcessingHelper';

interface IUploadPhotoProps {
  playerId: number;
  ownerRowGuid: string;
  photoId: string;
  photo: Blob;
  fileName: string;
  caption: string;
  headTypeId?: number;
  sortId?: number;
  isASetClub?: boolean;
  isBsg?: boolean;
}

interface IUpdatePhotoCaptionProps {
  storageObjectId: number;
  caption: string;
}

interface IDeletePhotoMetadataProps {
  storageObjectId: number;
}

export const uploadPhoto = async ({ playerId, ownerRowGuid, photoId, photo, fileName, caption, headTypeId, sortId, isASetClub, isBsg }: IUploadPhotoProps) => {
  const uploadFile = PhotoUploadHelper.createImageFile(photo, fileName);
  const processedImage = await processImageForUpload(uploadFile);
  const data = await PhotoUploadHelper.blobToBase64(processedImage.file);
  const payload = PhotoUploadHelper.buildGatewayImageUploadPayload({
    playerId,
    ownerRowGuid,
    photoId,
    data,
  });
  const response = await postGatewayImageNew(payload);
  const metadataResponse = await postSaveImageMetadata({
    EntityGuid: ownerRowGuid,
    FileName: response.fileName,
    ContentType: processedImage.file.type,
    Caption: caption,
    HeadTypeId: headTypeId,
    ...(sortId ? { SortId: sortId } : {}),
    ...(isASetClub ? { isASetClub } : {}),
    ...(isBsg ? { isBsg } : {}),
  });

  return {
    fileName: response.fileName,
    contentType: processedImage.file.type,
    metadata: metadataResponse.data,
  };
};

export const fetchPhotoBlob = async (fileName: string): Promise<Blob> => {
  const blob = await getGatewayImageFetch(fileName);
  return blob;
};

export const updatePhotoCaption = async ({ storageObjectId, caption }: IUpdatePhotoCaptionProps) => {
  const response = await postSaveImageMetadata({
    StorageObjectId: storageObjectId,
    Caption: caption,
  });
  return response;
};

export const deletePhotoMetadata = async ({ storageObjectId }: IDeletePhotoMetadataProps) => {
  const response = await postDeleteImageMetadata({
    StorageObjectId: storageObjectId,
  });
  return response;
};

export type { ImageMetadata };
